import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { MeasurementChart2TVersions } from "../../entities/tech-pack-versions/measurement-chart-2t-versions.entity";


@Injectable()
export class MeasurementChart2TVersionsRepo extends Repository<MeasurementChart2TVersions> {

    constructor(@InjectRepository(MeasurementChart2TVersions) private measurementChart2TRepo: Repository<MeasurementChart2TVersions>
    ) {
        super(measurementChart2TRepo.target, measurementChart2TRepo.manager, measurementChart2TRepo.queryRunner);
    }

}